import dynamic from "next/dynamic";
export * from "./types";

export const Telesales = dynamic(() =>
  import("./telesales").then(({ Telesales }) => Telesales)
);
